import { I18nResources } from '@app-velocity/i18n';

export const isActionConfirmationModal = (
  obj: Record<string, unknown>
): obj is {
  'action-confirmation': {
    onModalCloseCallback: (decision: 'OK' | 'CANCEL') => void;
    confirmButtonColor?: 'success' | 'error';
    title: I18nResources;
    description: I18nResources;
    confirmButtonText: I18nResources;
    cancelButtonText: I18nResources;
  };
} => {
  return obj['action-confirmation'] !== undefined;
};
